import { ITranslationEntry } from '../lang';

export const KA: ITranslationEntry = {
  translations: {
    notifications: 'ಅಧಿಸೂಚನೆಗಳು',
    markAllAsRead: 'ಎಲ್ಲವನ್ನು ಓದಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ',
    poweredBy: 'ಮೂಲಕ ನಡೆಸಲ್ಪಡುತ್ತಿದೆ',
    settings: 'ಸಂಯೋಜನೆಗಳು',
    noNewNotification: 'აქ ახალი სანახავი ჯერ არაფერია',
  },
  lang: 'ka',
};
